$('.reviews-slider-js').owlCarousel({
    dots: true,
    nav: true,
    navText: ['&larr;', '&rarr;'],

    // autoHeight:true,
    // margin: 30,
    responsive: {
        0: {
            items: 1,
        },
        700: {
            items: 2,
        },
        1100: {
            items: 3,
        },
    },
});

initButtons();

$('.review__more-btn button').click(function(e) {
    e.stopPropagation();
    let reviewBlock = this.closest('.review');
    if(this.classList.contains('opened')){
        reviewUp(reviewBlock);
    }else {
        reviewDown(reviewBlock);
    }
});

function initButtons() {
    let reviewBlocks = document.querySelectorAll('.review');
    reviewBlocks.forEach(reviewBlock => {
        let contentBlock = reviewBlock.querySelector('.review__content');
        let moreBtn = reviewBlock.querySelector('.review__more-btn button');
        let height = $(contentBlock).height();
        if(contentBlock.scrollHeight - height < 5) {
            if(!moreBtn.classList.contains('opened'))
                moreBtn.style.display = 'none';
        }else {
            moreBtn.style.display = 'inline-block';
            moreBtn.innerText = 'Развернуть отзыв';
        }
    });
}

function reviewDown(reviewBlock) {
    let contentBlock = reviewBlock.querySelector('.review__content');
    contentBlock.style.height = contentBlock.scrollHeight + 'px';
    let moreBtn = reviewBlock.querySelector('.review__more-btn button');
    moreBtn.classList.add('opened');
    moreBtn.innerText = 'Свернуть отзыв';
}

function reviewUp(reviewBlock) {
    let contentBlock = reviewBlock.querySelector('.review__content');
    contentBlock.style.height = '';
    let moreBtn = reviewBlock.querySelector('.review__more-btn button');
    moreBtn.classList.remove('opened');
    moreBtn.innerText = 'Развернуть отзыв';
}